import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSensitiveFlow } from '../../context/PwaUpdateContext';

export const field = 'mt-1 w-full min-w-0 rounded-xl border border-border bg-background px-3 py-2 text-sm text-foreground';
export const panel = 'min-w-0 rounded-xl border border-border bg-card p-4 sm:p-5';
export const errorText = e => typeof e.response?.data?.detail === 'string' ? e.response.data.detail : e.message || 'Kunde inte slutföra. Försök igen.';
export function useMatchText() {
  const { i18n } = useTranslation();
  return (sv, en) => i18n.language?.startsWith('en') ? en : sv;
}

// Per user/team/document. Preserve the base revision so restoring never bypasses CAS.
export function useWorkspaceDraft(key, initial, onDirtyChange, allowRestore = true) {
  const [restored] = useState(() => { try { return allowRestore ? JSON.parse(sessionStorage.getItem(key) || 'null') : null; } catch (_) { return null; } });
  const [value, setValue] = useState(restored || initial);
  const [dirty, setDirty] = useState(!!restored), [cacheError, setCacheError] = useState(false);
  useEffect(() => { if (!dirty) setValue(initial); }, [initial, dirty]);
  useSensitiveFlow(dirty);
  useEffect(() => { onDirtyChange?.(dirty); return () => onDirtyChange?.(false); }, [dirty, onDirtyChange]);
  useEffect(() => {
    if (!dirty) return undefined;
    const warn = e => { e.preventDefault(); e.returnValue = ''; };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [dirty]);
  const backup = next => {
    try { sessionStorage.setItem(key, JSON.stringify(next)); } catch (_) { setCacheError(true); }
  };
  const change = next => {
    setValue(next); setDirty(true); backup(next);
  };
  const clear = next => {
    try { sessionStorage.removeItem(key); } catch (_) { /* optional cache */ }
    setDirty(false); if (next) setValue(next);
  };
  return { value, change, clear, backup, dirty, restored: !!restored, cacheError };
}
